import { createElementVNode as _createElementVNode, openBlock as _openBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "h-screen flex overflow-hidden" };
const _hoisted_2 = {
    class: "fixed inset-0 flex z-40 md:hidden",
    role: "dialog",
    "aria-modal": "true"
};
const _hoisted_3 = { class: "relative flex-1 flex flex-col max-w-xs w-full bg-slate-800" };
const _hoisted_4 = { class: "absolute top-0 right-0 -mr-12 pt-2" };
const _hoisted_5 = { class: "flex-1 flex flex-col pt-5 pb-4 overflow-y-auto" };
const _hoisted_6 = {
    class: "flex lg:hidden items-center flex-shrink-0 px-4 text-brand-600",
    role: "banner"
};
const _hoisted_7 = {
    href: "#main_content",
    name: "main_content",
    tabindex: "-1",
    class: "navigation-logo"
};
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
    role: "navigation",
    class: "admin-side-nav mt-5 flex-1 px-2 bg-slate-800 space-y-1"
};
const _hoisted_10 = { class: "fixed bottom-0 left-0 w-80 flex-shrink-0 flex bg-slate-700 text-slate-100 px-2 py-4" };
const _hoisted_11 = { class: "flex items-center text-brand-300" };
const _hoisted_12 = { class: "block w-32" };
const _hoisted_13 = { class: "hidden md:flex md:flex-shrink-0" };
const _hoisted_14 = { class: "flex flex-col w-64" };
const _hoisted_15 = { class: "flex flex-col h-0 flex-1 bg-slate-800" };
const _hoisted_16 = {
    href: "#main_content",
    name: "main_content",
    tabindex: "-1",
    class: "navigation-logo"
};
const _hoisted_17 = ["src", "alt"];
const _hoisted_18 = {
    role: "navigation",
    class: "admin-side-nav mt-5 flex-1 px-2 bg-slate-800 space-y-1"
};
const _hoisted_19 = { class: "fixed bottom-0 left-0 w-64 flex-shrink-0 flex bg-slate-700 text-slate-100 px-2 py-4" };
const _hoisted_20 = { class: "flex items-center text-brand-300" };
const _hoisted_21 = { class: "block w-32" };
const _hoisted_22 = { class: "overflow-scroll pb-8 w-full" };
const _hoisted_23 = { class: "md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3" };
const _hoisted_24 = {
    role: "main",
    class: "admin-content p-6 text-slate-800"
};
const _hoisted_25 = {
    class: "admin-content flex items-center fixed bottom-0 left-0 md:left-64 right-0 bg-slate-800 p-2 text-xs text-slate-400",
    role: "contentinfo"
};
const _hoisted_26 = { class: "flex flex-1" };
const _hoisted_27 = { class: "mr-2" };
const _hoisted_28 = ["href"];
const _hoisted_29 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_router_view = _resolveComponent("router-view");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, {
            "enter-active-class": "transition ease-in-out duration-300 transform",
            "enter-from-class": "-translate-x-full",
            "enter-to-class": "translate-x-0",
            "leave-active-class": "transition ease-in-out duration-300 transform",
            "leave-from-class": "translate-x-0",
            "leave-to-class": "-translate-x-full"
        }, {
            default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_2, [
                    _cache[15] || (_cache[15] = _createElementVNode("div", {
                        class: "fixed inset-0 bg-slate-600 bg-opacity-75",
                        "aria-hidden": "true"
                    }, null, -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("button", {
                                class: "ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.closeSideBar()), ["prevent"]))
                            }, [...(_cache[4] || (_cache[4] = [
                                    _createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1),
                                    _createElementVNode("svg", {
                                        class: "h-6 w-6 text-white",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M6 18L18 6M6 6l12 12"
                                        })
                                    ], -1)
                                ]))])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_router_link, {
                                to: { name: 'admin.dashboard' },
                                onClick: _ctx.closeSideBar
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("header", _hoisted_6, [
                                        _createElementVNode("a", _hoisted_7, [
                                            _createElementVNode("img", {
                                                src: _ctx.asset('img/logo.svg'),
                                                alt: _ctx.app.name,
                                                class: "mx-auto"
                                            }, null, 8, _hoisted_8)
                                        ])
                                    ])
                                ]),
                                _: 1
                            }, 8, ["onClick"]),
                            _createElementVNode("nav", _hoisted_9, [
                                _createVNode(_component_router_link, {
                                    to: { name: 'admin.dashboard' },
                                    onClick: _ctx.closeSideBar
                                }, {
                                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                focusable: "false"
                                            }, [
                                                _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                                                })
                                            ], -1),
                                            _createTextVNode(" Dashboard ", -1)
                                        ]))]),
                                    _: 1
                                }, 8, ["onClick"]),
                                (_ctx.permissions.isAdmin())
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        to: { name: 'admin.account' },
                                        onClick: _ctx.closeSideBar
                                    }, {
                                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    class: "h-6 w-6",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    focusable: "false"
                                                }, [
                                                    _createElementVNode("path", {
                                                        "stroke-linecap": "round",
                                                        "stroke-linejoin": "round",
                                                        d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                                    })
                                                ], -1),
                                                _createTextVNode(" Accounts ", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["onClick"]))
                                    : (!_ctx.permissions.isGuest())
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 1,
                                            to: { name: 'admin.account.manage', params: { slug: _ctx.permissions.getAccountSlug() } },
                                            onClick: _ctx.closeSideBar
                                        }, {
                                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        class: "h-6 w-6",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                        "stroke-width": "2",
                                                        focusable: "false"
                                                    }, [
                                                        _createElementVNode("path", {
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                                        })
                                                    ], -1),
                                                    _createTextVNode(" Account ", -1)
                                                ]))]),
                                            _: 1
                                        }, 8, ["to", "onClick"]))
                                        : _createCommentVNode("", true),
                                (!_ctx.permissions.isGuest())
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 2,
                                        to: { name: 'admin.user' },
                                        onClick: _ctx.closeSideBar
                                    }, {
                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    class: "h-6 w-6",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    focusable: "false"
                                                }, [
                                                    _createElementVNode("path", {
                                                        "stroke-linecap": "round",
                                                        "stroke-linejoin": "round",
                                                        d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                                                    })
                                                ], -1),
                                                _createTextVNode(" Users ", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                (!_ctx.permissions.isGuest())
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 3,
                                        to: { name: 'admin.campaign' },
                                        onClick: _ctx.closeSideBar
                                    }, {
                                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    class: "h-6 w-6",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    focusable: "false"
                                                }, [
                                                    _createElementVNode("path", {
                                                        "stroke-linecap": "round",
                                                        "stroke-linejoin": "round",
                                                        d: "M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                                                    })
                                                ], -1),
                                                _createTextVNode(" Campaigns ", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                (!_ctx.permissions.isGuest())
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 4,
                                        to: { name: 'admin.order' },
                                        onClick: _ctx.closeSideBar
                                    }, {
                                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    class: "h-6 w-6",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    focusable: "false"
                                                }, [
                                                    _createElementVNode("path", {
                                                        "stroke-linecap": "round",
                                                        "stroke-linejoin": "round",
                                                        d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                                                    })
                                                ], -1),
                                                _createTextVNode(" Orders ", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                (!_ctx.permissions.isGuest())
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 5,
                                        to: { name: 'admin.report' },
                                        onClick: _ctx.closeSideBar
                                    }, {
                                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    class: "h-6 w-6",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    focusable: "false"
                                                }, [
                                                    _createElementVNode("path", {
                                                        "stroke-linecap": "round",
                                                        "stroke-linejoin": "round",
                                                        d: "M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
                                                    }),
                                                    _createElementVNode("path", {
                                                        "stroke-linecap": "round",
                                                        "stroke-linejoin": "round",
                                                        d: "M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
                                                    })
                                                ], -1),
                                                _createTextVNode(" Reports ", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _cache[14] || (_cache[14] = _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        class: "h-12 w-12 mr-2",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        role: "img",
                                        focusable: "false",
                                        "aria-label": "Settings"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                                        }),
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                        })
                                    ], -1)),
                                    _createVNode(_component_router_link, {
                                        to: { name: 'admin.settings' },
                                        class: "text-slate-100 text-sm w-full hover:text-brand-200",
                                        onClick: _ctx.closeSideBar
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.app.auth.name), 1),
                                            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-slate-300" }, "Account", -1))
                                        ]),
                                        _: 1
                                    }, 8, ["onClick"]),
                                    _createElementVNode("a", {
                                        href: "#",
                                        type: "button",
                                        class: "text-brand-300",
                                        "aria-label": "Logout",
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.authentication.signOut()), ["prevent"]))
                                    }, [...(_cache[13] || (_cache[13] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                class: "h-8 w-8 ml-2",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                "stroke-width": "2",
                                                role: "img",
                                                focusable: "true",
                                                "aria-label": "Logout"
                                            }, [
                                                _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                                })
                                            ], -1)
                                        ]))])
                                ])
                            ])
                        ])
                    ])
                ], 512), [
                    [_vShow, _ctx.sideBarOpen]
                ])
            ]),
            _: 1
        }),
        _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_router_link, {
                        to: { name: 'admin.dashboard' },
                        class: "navigation-logo pt-4 px-4"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("a", _hoisted_16, [
                                _createElementVNode("img", {
                                    src: _ctx.asset('img/logo.svg'),
                                    alt: _ctx.app.name,
                                    class: "mx-auto"
                                }, null, 8, _hoisted_17)
                            ])
                        ]),
                        _: 1
                    }),
                    _createElementVNode("nav", _hoisted_18, [
                        _createVNode(_component_router_link, {
                            to: { name: 'admin.dashboard' },
                            onClick: _ctx.closeSideBar
                        }, {
                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                    _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        focusable: "false"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                                        })
                                    ], -1),
                                    _createTextVNode(" Dashboard ", -1)
                                ]))]),
                            _: 1
                        }, 8, ["onClick"]),
                        (_ctx.permissions.isAdmin())
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: { name: 'admin.account' },
                                onClick: _ctx.closeSideBar
                            }, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-6 w-6",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            focusable: "false"
                                        }, [
                                            _createElementVNode("path", {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                            })
                                        ], -1),
                                        _createTextVNode(" Accounts ", -1)
                                    ]))]),
                                _: 1
                            }, 8, ["onClick"]))
                            : (!_ctx.permissions.isGuest())
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    to: { name: 'admin.account.manage', params: { slug: _ctx.permissions.getAccountSlug() } },
                                    onClick: _ctx.closeSideBar
                                }, {
                                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                class: "h-6 w-6",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                "stroke-width": "2",
                                                focusable: "false"
                                            }, [
                                                _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                                })
                                            ], -1),
                                            _createTextVNode(" Account ", -1)
                                        ]))]),
                                    _: 1
                                }, 8, ["to", "onClick"]))
                                : _createCommentVNode("", true),
                        (!_ctx.permissions.isGuest())
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 2,
                                to: { name: 'admin.user' },
                                onClick: _ctx.closeSideBar
                            }, {
                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-6 w-6",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            focusable: "false"
                                        }, [
                                            _createElementVNode("path", {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                                            })
                                        ], -1),
                                        _createTextVNode(" Users ", -1)
                                    ]))]),
                                _: 1
                            }, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                        (!_ctx.permissions.isGuest())
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 3,
                                to: { name: 'admin.campaign' },
                                onClick: _ctx.closeSideBar
                            }, {
                                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-6 w-6",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            focusable: "false"
                                        }, [
                                            _createElementVNode("path", {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                d: "M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                                            })
                                        ], -1),
                                        _createTextVNode(" Campaigns ", -1)
                                    ]))]),
                                _: 1
                            }, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                        (!_ctx.permissions.isGuest())
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 4,
                                to: { name: 'admin.order' },
                                onClick: _ctx.closeSideBar
                            }, {
                                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-6 w-6",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            focusable: "false"
                                        }, [
                                            _createElementVNode("path", {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                                            })
                                        ], -1),
                                        _createTextVNode(" Orders ", -1)
                                    ]))]),
                                _: 1
                            }, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                        (!_ctx.permissions.isGuest())
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 5,
                                to: { name: 'admin.report' },
                                onClick: _ctx.closeSideBar
                            }, {
                                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-6 w-6",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            focusable: "false"
                                        }, [
                                            _createElementVNode("path", {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                d: "M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
                                            }),
                                            _createElementVNode("path", {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                d: "M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
                                            })
                                        ], -1),
                                        _createTextVNode(" Reports ", -1)
                                    ]))]),
                                _: 1
                            }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                            _cache[25] || (_cache[25] = _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-12 w-12 mr-2",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                role: "img",
                                focusable: "false",
                                "aria-label": "Settings"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                                }),
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                })
                            ], -1)),
                            _createVNode(_component_router_link, {
                                to: { name: 'admin.settings' },
                                class: "text-slate-100 text-sm w-full hover:text-brand-200",
                                onClick: _ctx.closeSideBar
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.app.auth.name), 1),
                                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-slate-300" }, "Account", -1))
                                ]),
                                _: 1
                            }, 8, ["onClick"]),
                            _createElementVNode("a", {
                                href: "#",
                                type: "button",
                                class: "text-brand-300",
                                "aria-label": "Logout",
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.authentication.signOut()), ["prevent"]))
                            }, [...(_cache[24] || (_cache[24] = [
                                    _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        class: "h-8 w-8 ml-2",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        role: "img",
                                        focusable: "true",
                                        "aria-label": "Logout"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                        })
                                    ], -1)
                                ]))])
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                    class: "-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-slate-500 hover:text-slate-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.toggleSideBar && _ctx.toggleSideBar(...args)), ["prevent"]))
                }, [...(_cache[26] || (_cache[26] = [
                        _createElementVNode("span", { class: "sr-only" }, "Open sidebar", -1),
                        _createElementVNode("svg", {
                            class: "h-6 w-6",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            "aria-hidden": "false"
                        }, [
                            _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M4 6h16M4 12h16M4 18h16"
                            })
                        ], -1)
                    ]))])
            ]),
            _createElementVNode("main", _hoisted_24, [
                _createVNode(_component_router_view, { app: _ctx.app }, null, 8, ["app"])
            ]),
            _createElementVNode("footer", _hoisted_25, [
                _createElementVNode("ul", _hoisted_26, [
                    _cache[27] || (_cache[27] = _createElementVNode("li", { class: "mr-2" }, [
                        _createElementVNode("a", {
                            href: "/privacy",
                            class: "alt",
                            target: "_blank"
                        }, "Privacy Policy")
                    ], -1)),
                    _cache[28] || (_cache[28] = _createElementVNode("li", { class: "mr-2" }, [
                        _createElementVNode("a", {
                            href: "/terms",
                            class: "alt",
                            target: "_blank"
                        }, "Terms of Service")
                    ], -1)),
                    _createElementVNode("li", _hoisted_27, [
                        _createElementVNode("a", {
                            href: _ctx.app.status_url,
                            class: "alt hidden xl:flex",
                            target: "_blank"
                        }, "System Status", 8, _hoisted_28)
                    ])
                ]),
                _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_ctx.app.name) + " " + _toDisplayString(_ctx.app.version) + " © ", 1),
                    _createElementVNode("a", {
                        href: _ctx.app.copyright.name,
                        class: "alt",
                        target: "_blank"
                    }, _toDisplayString(_ctx.app.copyright.name), 9, _hoisted_29),
                    _cache[29] || (_cache[29] = _createTextVNode(". ", -1))
                ])
            ])
        ])
    ]));
}
